import { render, staticRenderFns } from "./CommerceDebutGuide.vue?vue&type=template&id=c17cb04a&scoped=true"
import script from "./CommerceDebutGuide.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommerceDebutGuide.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CommerceDebutGuide.vue?vue&type=style&index=0&id=c17cb04a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17cb04a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c17cb04a')) {
      api.createRecord('c17cb04a', component.options)
    } else {
      api.reload('c17cb04a', component.options)
    }
    module.hot.accept("./CommerceDebutGuide.vue?vue&type=template&id=c17cb04a&scoped=true", function () {
      api.rerender('c17cb04a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/CommerceDebutGuide.vue"
export default component.exports